<template>
    <div>
        <section class="intro container">
            <img :src="'/static/img/shamal-office.jpg'" alt="">



            <h2 class="text-center">Solutions we provide </h2>

            <p class="text-center introp">
                B2B specialists with over a decade of experience across different industry verticals, we custom-create
                effective communications strategies for both high profile corporate clients and new-to-market
                businesses.
            </p>
            <div class="tools">
                <a :href="'/what-we-do/'">

                    <span class="icon-briefcase"></span>
                    <h4>Corporate PR</h4>
                </a>

                 <a :href="'/what-we-do/'">
                    <span class="icon-genius"></span>
                    <h4>Consumer PR</h4>
                </a>

                 <a :href="'/what-we-do/'">
                    <span class="icon-strategy"></span>
                    <h4>Strategic Advisory</h4>
                </a>

                 <a :href="'/what-we-do/'">
                    <span class="icon-megaphone"></span>
                    <h4>Events PR</h4>
                </a>
                 <a :href="'/what-we-do/'">
                    <span class="icon-chat"></span>
                    <h4>Digital Media</h4>
                </a>
            </div>


        </section>
    </div>
</template>
<script>
    export default {
        props: []
    }
</script>
<style scoped lang="scss">
    section {
        padding: 30px ;
    }

    .tools {
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 960px;
    width: 100%;
    margin: 35px auto;

        > a {
            margin: 1px;
            cursor: pointer;
            transition: all 0.3s ease;
        }

        > a:hover {
            transform: scale(1.1);
            background: rgba(255, 255, 255, 0.25);
        }
}

    .introp {
        max-width: 900px;
        margin: auto;
    }

    section h2 {


    font-weight: 700;

    margin: 50px 0 30px;
}

    .tools > a {
    flex: 0 0 32.33%;
    max-width: 33.33%;
    padding: 30px;
}
.tools > a > span {
    font-size: 70px;
    color: #A7975F;

}

.tools > a h4 {
    font-size: 16px;
    color: #444;
    font-weight: 700;
    margin-top: 10px;

}


</style>